import React from 'react';
const tomos = [{
  emoji: '📘',
  title: 'Tomo 1 — El Positivo y la Hoja de Ruta',
  desc: 'Semanas 1 a 12. Qué hacer exactamente en las primeras 48 horas después del positivo. El sistema de salud argentino explicado sin tecnicismos: OSDE, prepagas, hospital público, PMI. Primera ecografía, análisis de primer trimestre y hoja de ruta médica semana a semana. La base que te saca del pánico inicial y te pone en modo acción desde el día uno.'
}, {
  emoji: '📗',
  title: 'Tomo 2 — Cuerpo, Cambios y Nutrición',
  desc: 'Semanas 13 a 27. Los cambios del cuerpo semana a semana explicados con honestidad real. Plan de alimentación adaptado a la dieta argentina con hierro, calcio y omega 3. La verdad sobre el peso en el embarazo sin presión ni culpa. Los movimientos fetales, la hoja de ruta médica del segundo trimestre y tus derechos laborales como embarazada en Argentina.'
}, {
  emoji: '📙',
  title: 'Tomo 3 — El Nido: Compras Inteligentes',
  desc: 'La guía anti-marketing de puericultura. El sistema de las 3 categorías para no tirar plata en cosas innecesarias. Qué comprar nuevo sí o sí, qué conviene usado sin ningún problema y qué no comprar todavía. El presupuesto real del bebé en Argentina con precios de referencia actualizados. Cómo armar el baby shower estratégicamente para recibir exactamente lo que necesitás.'
}, {
  emoji: '📕',
  title: 'Tomo 4 — Preparación Física y Mental',
  desc: 'El entrenamiento para el día más importante. Rutinas de movimiento prenatal adaptadas a todos los niveles, incluyendo las que nunca hicieron ejercicio. El suelo pélvico: la parte del cuerpo más importante que nadie te enseñó a preparar. Las 3 técnicas de respiración para el trabajo de parto practicadas y automatizadas antes del día D. Manejo de la ansiedad y los miedos con herramientas concretas y aplicables.'
}, {
  emoji: '📓',
  title: 'Tomo 5 — El Plan de Parto y la Clínica',
  desc: 'Tu voz en la sala de partos. La Ley 25.929 de Parto Humanizado explicada artículo por artículo en lenguaje simple. Cómo redactar, presentar y hacer respetar tu plan de parto. La fisiología completa del trabajo de parto sin términos médicos confusos. Todo sobre la epidural, la episiotomía y la cesárea para decidir con información real. El bolso de clínica: la lista exacta dividida en 3 bolsos para no olvidar nada a las 3 de la mañana.'
}, {
  emoji: '📔',
  title: 'Tomo 6 — Golden Hour: Los Primeros 10 Días',
  desc: 'Manual de supervivencia postparto. Las primeras horas en casa con tu bebé sin entrar en pánico. La verdad sobre la lactancia que nadie te dice antes de que nazca el bebé. El sueño del recién nacido con expectativas reales y estrategias prácticas para manejarlo. Baby blues vs. depresión postparto: cómo reconocerla y cómo pedir ayuda. Tu recuperación física postparto y todos los signos de alerta del recién nacido.'
}];
const checklist = ['Implementación inmediata desde la primera página', 'Checklists y plantillas listas para usar', 'Casos y ejemplos adaptados a Argentina', 'Hojas de trabajo completables', 'Tablas y guías de referencia rápida', 'Lenguaje argentino real (obstetra, prepaga, PMI, ANSES)', '100% adaptado al sistema de salud argentino 2025'];
const bonos = [{
  num: '01',
  title: 'Kit de Checklists de Supervivencia',
  desc: 'Las listas que te ahorran olvidos, ansiedad y caos desde el positivo hasta la llegada a casa. Del primer positivo al regreso del sanatorio, cada paso organizado en listas simples para marcar. Bolso de clínica mamá y bebé, señales de alerta, primeras compras divididas por prioridad y seguimiento diario de los primeros 10 días. El quick win más inmediato de todo el pack.',
  value: '$15.000'
}, {
  num: '02',
  title: 'Guía Express de Compras Inteligentes del Bebé',
  desc: 'Comprá solo lo que realmente necesitás y evitá tirar plata en productos que no vas a usar. El sistema de las 3 categorías aplicado artículo por artículo: imprescindible, puede esperar, no comprar todavía. Tabla de nuevo vs. usado en Argentina, presupuesto real por prioridad y los 10 errores de compra más comunes de las primerizas argentinas. Ahorro real garantizado desde la primera lectura.',
  value: '$12.000'
}, {
  num: '03',
  title: 'Planificador de Turnos, Estudios y Fechas Clave',
  desc: 'Todos tus controles, estudios y resultados organizados en un solo lugar. Calendario mensual del embarazo mes a mes, registro completo de turnos con el obstetra, tracker de estudios y análisis con resultados, banco de preguntas sugeridas por trimestre y hoja maestra imprimible. El organizador que hace que llegues a cada consulta preparada y sin olvidar nada importante.',
  value: '$12.000'
}, {
  num: '04',
  title: 'Mini Guía de Alivio Rápido para Síntomas Comunes',
  desc: 'Soluciones rápidas y prácticas para náuseas, acidez, hinchazón y cansancio sin entrar en pánico. Cada síntoma tiene su sección con explicación, estrategias de alivio inmediato y tabla de normal vs. consultar. Náuseas, acidez, cansancio extremo, hinchazón, constipación, dolor lumbar, calambres e insomnio del embarazo. El recurso que reemplaza la búsqueda ansiosa en Google a las 2 de la mañana.',
  value: '$12.000'
}, {
  num: '05',
  title: 'Guía Papá a Bordo',
  desc: 'El manual simple para que la pareja sepa cómo acompañarte de verdad antes, durante y después del parto. Lo que una embarazada primeriza realmente necesita explicado sin rodeos ni vueltas. Cómo acompañar trimestre por trimestre, qué decir y qué no decir nunca, el rol exacto el día del parto y la división real de tareas en los primeros 10 días. La guía que convierte a la pareja de espectador perdido en co-protagonista activo.',
  value: '$15.000'
}, {
  num: '06',
  title: 'Plan de Regreso a Casa sin Caos',
  desc: 'Organizá las primeras 72 horas en casa con tu bebé para sentirte contenida, preparada y mucho menos desbordada. Plan detallado hora por hora de las primeras 24, 24 a 48 y 48 a 72 horas. Cómo preparar la casa antes del nacimiento, organizador de ayuda externa con roles asignados, mini plan de comidas para los primeros 10 días y checklist de recuperación de la mamá. El plan que convierte el momento más caótico en algo completamente manejable.',
  value: '$15.000'
}];
export function SolutionSection() {
  return <section className="py-16 md:py-24 border-y border-pink-200 bg-white/30 backdrop-blur-sm" data-id="element-144">
      <div className="max-w-6xl mx-auto px-4" data-id="element-145">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-146">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-fuchsia-100 text-fuchsia-600 font-bold text-sm mb-6 border border-fuchsia-200" data-id="element-147">
            🏆 MEGA PACK MAMÁ PRIMERIZA™
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-148">
            6 Tomos + 6 Bonos de Aplicación Inmediata
          </h2>
          <p className="text-lg md:text-xl text-gray-700" data-id="element-149">
            El Sistema N°1 para Mamás Primerizas en Argentina
          </p>
          <p className="text-base text-gray-500 mt-2" data-id="element-150">
            Más de 300 páginas — todo listo para usar desde hoy.
          </p>
        </div>

        {/* Tomos Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-12 md:mb-16" data-id="element-151">
          {tomos.map((t, i) => <div key={i} className="bg-white shadow-lg border border-pink-200 rounded-2xl p-6 md:p-8 hover:border-fuchsia-300 transition-all group" data-id="element-152">
              <div className="text-4xl md:text-5xl mb-5 group-hover:scale-110 transition-transform origin-left" data-id="element-153">
                {t.emoji}
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3" data-id="element-154">
                {t.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm md:text-base" data-id="element-155">
                {t.desc}
              </p>
            </div>)}
        </div>

        {/* Checklist */}
        <div className="max-w-3xl mx-auto bg-white/90 backdrop-blur-sm shadow-xl border border-pink-200 rounded-2xl md:rounded-3xl p-6 md:p-10 mb-20 md:mb-28" data-id="element-156">
          <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-6 md:mb-8 text-center" data-id="element-157">
            Cada tomo incluye:
          </h3>
          <div className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-158">
            {checklist.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-159">
                <span className="text-fuchsia-500 mt-0.5 shrink-0" data-id="element-160">✅</span>
                <span className="text-gray-700 font-medium text-sm md:text-base" data-id="element-161">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        {/* Bonuses Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-162">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-163">
            🎁 6 BONOS DE APLICACIÓN INMEDIATA
          </h2>
          <p className="text-lg text-fuchsia-600 font-semibold uppercase tracking-wider" data-id="element-164">
            Siempre incluidos
          </p>
        </div>

        {/* Bonuses Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-12 md:mb-16" data-id="element-165">
          {bonos.map((b, i) => <div key={i} className="bg-gradient-to-b from-white to-pink-50 shadow-lg border border-pink-200 rounded-2xl p-6 md:p-8 relative overflow-hidden flex flex-col" data-id="element-166">
              <div className="absolute top-0 right-0 w-28 h-28 bg-fuchsia-100/50 rounded-bl-full -mr-8 -mt-8" data-id="element-167" />
              <div className="text-fuchsia-600 font-mono font-bold text-lg mb-3 relative z-10" data-id="element-168">
                BONO {b.num}
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 relative z-10" data-id="element-169">
                {b.title}
              </h3>
              <p className="text-gray-600 text-sm md:text-base mb-6 flex-1 relative z-10" data-id="element-170">
                {b.desc}
              </p>
              <div className="pt-5 border-t border-pink-200 flex items-center justify-between relative z-10" data-id="element-171">
                <span className="text-gray-400 line-through font-mono text-sm" data-id="element-172">
                  {b.value}
                </span>
                <span className="bg-fuchsia-100 text-fuchsia-700 font-bold px-3 py-1 rounded-md text-xs uppercase tracking-wide" data-id="element-173">
                  Gratis
                </span>
              </div>
            </div>)}
        </div>

        {/* Total Value */}
        <div className="max-w-xl mx-auto text-center bg-fuchsia-50 border border-fuchsia-200 rounded-2xl p-6 md:p-8 shadow-md" data-id="element-174">
          <div className="text-gray-600 font-medium mb-2 uppercase tracking-wider text-sm" data-id="element-175">
            Valor total bonos
          </div>
          <div className="text-2xl md:text-3xl font-bold" data-id="element-176">
            <span className="line-through text-gray-400 mr-3" data-id="element-177">$81.000</span>
            <span className="text-fuchsia-600" data-id="element-178">→ GRATIS con tu Mega Pack</span>
          </div>
        </div>
      </div>
    </section>;
}